// extracted by mini-css-extract-plugin
module.exports = {"content":"destacatCercadorPrevisio_content__9IcPp","cercador":"destacatCercadorPrevisio_cercador__QjPTp"};